
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinars",
      function () {
        return require("private-next-pages/webinars/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webinars"])
      });
    }
  